import Badge from '@material-ui/core/Badge';
import ButtonBase from '@material-ui/core/ButtonBase';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';

const ResponsePreview = props => {
  const classes = useStyles();
  return (
    <ButtonBase className={classes.buttonBase} onClick={props.onClick}>
      <div className={classes.root}>
        <div className={classes.listItem}>
          <ListItem>
            <ListItemText
              primary={props.propertyDisplayName}
              secondary={props.userDisplayName ? `${props.userDisplayName}: ${props.lastMessage}` : props.lastMessage}
            />
          </ListItem>
        </div>
        <div className={classes.metadata}>
          <span className={classes.timestamp}>{getFormattedDateString(props.timestamp)}</span>
          {props.unreadMessagesCount > 0 && (
            <Badge className={classes.badge} badgeContent={props.unreadMessagesCount} color='error' />
          )}
        </div>
      </div>
    </ButtonBase>
  );
};

const getFormattedDateString = timestamp => {
  const timestampMoment = moment(timestamp);
  const currentMoment = moment();
  if (timestampMoment.isSame(currentMoment, 'day')) {
    return timestampMoment.format('HH:mm');
  } else if (timestampMoment.isAfter(currentMoment.clone().subtract(7, 'days'), 'day')) {
    return timestampMoment.format('ddd');
  } else if (timestampMoment.isAfter(currentMoment.clone().subtract(1, 'years'), 'month')) {
    return timestampMoment.format('MMM D');
  } else {
    return timestampMoment.format('M/D/YY');
  }
};

const useStyles = makeStyles(theme => {
  return {
    buttonBase: {
      width: '100%'
    },
    root: {
      width: '100%',
      display: 'flex',
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      }
    },
    listItem: {
      flex: 1
    },
    metadata: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end'
    },
    timestamp: {
      marginRight: 16,
      marginTop: 20,
      fontSize: 12,
      color: theme.palette.text.secondary
    },
    badge: {
      marginRight: 26,
      marginTop: 10
    }
  };
});

const mapStateToProps = (state, ownProps) => {
  const property = state.properties.byId[ownProps.propertyId];
  const propertyDisplayName = property !== undefined ? property.displayName : null;
  const user = state.users.byId[ownProps.userId];
  const userDisplayName = user !== undefined ? user.displayName : null;
  return { propertyDisplayName, userDisplayName };
};

export default connect(mapStateToProps)(ResponsePreview);